<h2 mat-dialog-title>Edit test info</h2>

<form [formGroup]="form">
  <p>The selections below will change the contents of the test info table on the cover page</p>

  <div class="dialog-section">
    <div class="switches-section">
      <div class="configuration-switches">
        <mat-checkbox class="configuration-switch" formControlName="date">Show test date</mat-checkbox>
        <mat-checkbox class="configuration-switch" formControlName="sport">Show sport</mat-checkbox>
        <mat-checkbox class="configuration-switch" formControlName="athlete">Show athlete name</mat-checkbox>
        <mat-checkbox class="configuration-switch" formControlName="coach">Show coach name</mat-checkbox>
        <mat-checkbox class="configuration-switch" formControlName="testDisplayId">Show test ID</mat-checkbox>
        <mat-checkbox class="configuration-switch" formControlName="testType">Show test type</mat-checkbox>
      </div>
    </div>
  </div>
</form>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="onUpdate()">Update</button>
</mat-dialog-actions>
